import type { ApiPriceBook, SfTag } from '@/apiTypes'
import { PbProductType } from '@/enums/PbProductType'
import { PbSubcategory } from '@/enums/PbSubcategory'

function makeTags(tags: SfTag[]) {
	const innerTags = tags.map((tag) => ({
		topic: {
			data: {
				id: tag.id,
				name: tag.name,
			},
		},
	}))

	return {
		data: innerTags,
	}
}

export function PriceBookExample(): ApiPriceBook {
	const imageUrl = 'https://placehold.co/600x400?text=Example+Price+Book'
	const tagMetalCasket = {
		id: '1',
		name: 'Metal',
	}
	const tagPremiumCasket = {
		id: '2',
		name: 'Premium',
	}
	const tagMetalUrn = {
		id: '3',
		name: 'Metal',
	}
	const tagBasicCasket = {
		id: '4',
		name: 'Basic',
	}
	const tagWoodCasket = {
		id: '5',
		name: 'Wood',
	}
	const tagPremiumUrn = {
		id: '6',
		name: 'Premium',
	}
	const tagBasicUrn = {
		id: '7',
		name: 'Basic',
	}
	return {
		id: '0',
		name: 'Example Price Book',
		isPackageProductRemoval: true,
		gsMapping: 'Group States',
		externalGplUrl: 'https://web.precoa.com/bq_test_2024/test.pdf',
		lineItems: {
			data: [
				{
					id: '1',
					name: 'Gold Casket',
					description: 'A very nice gold casket.',
					isGuaranteed: true,
					fixedPrice: 11000,
					category: PbProductType.Merchandise,
					subcategory: PbSubcategory.MerchandiseCasket,
					productImageUrl: imageUrl,
					recordType: 'Product',
					refSpbPricingRecommended: null,
					packageRelations: null,
					pricingType: 'Fixed',
					pricing: null,
					topicAssignments: makeTags([tagMetalCasket, tagPremiumCasket]),
					isStandIn: false,
				},
				{
					id: '2',
					name: 'Bronze Casket',
					description: 'An OK bronze casket.',
					isGuaranteed: true,
					fixedPrice: 10000,
					category: PbProductType.Merchandise,
					subcategory: PbSubcategory.MerchandiseCasket,
					productImageUrl: imageUrl,
					recordType: 'Product',
					refSpbPricingRecommended: null,
					packageRelations: null,
					pricingType: 'Fixed',
					pricing: null,
					topicAssignments: makeTags([tagMetalCasket, tagBasicCasket]),
					isStandIn: false,
				},
				{
					id: '3',
					name: 'Oak Casket',
					description: 'A fancy casket mnade of oak.',
					isGuaranteed: true,
					fixedPrice: 9000,
					category: PbProductType.Merchandise,
					subcategory: PbSubcategory.MerchandiseCasket,
					productImageUrl: imageUrl,
					recordType: 'Product',
					refSpbPricingRecommended: null,
					packageRelations: null,
					pricingType: 'Fixed',
					pricing: null,
					topicAssignments: makeTags([tagWoodCasket, tagPremiumCasket]),
					isStandIn: false,
				},
				{
					id: '4',
					name: 'Pine Casket',
					description: 'The cheapest casket.',
					isGuaranteed: true,
					fixedPrice: 3500,
					category: PbProductType.Merchandise,
					subcategory: PbSubcategory.MerchandiseCasket,
					productImageUrl: imageUrl,
					recordType: 'Product',
					refSpbPricingRecommended: null,
					packageRelations: null,
					pricingType: 'Fixed',
					pricing: null,
					topicAssignments: makeTags([tagWoodCasket, tagBasicCasket]),
					isStandIn: false,
				},
				{
					id: '4.5',
					name: 'Alternative Container',
					description: '',
					isGuaranteed: true,
					fixedPrice: 210,
					category: PbProductType.Merchandise,
					subcategory: PbSubcategory.MerchandiseCasket,
					productImageUrl: imageUrl,
					recordType: 'Product',
					refSpbPricingRecommended: null,
					packageRelations: null,
					pricingType: 'Fixed',
					pricing: null,
					topicAssignments: null,
					isStandIn: false,
				},
				{
					id: '5',
					name: 'Titanium Urn',
					description: 'A space-age urn for all of your ashes.',
					isGuaranteed: true,
					fixedPrice: 25000,
					category: PbProductType.Merchandise,
					subcategory: PbSubcategory.MerchandiseUrn,
					productImageUrl: imageUrl,
					recordType: 'Product',
					refSpbPricingRecommended: null,
					packageRelations: null,
					pricingType: 'Fixed',
					pricing: null,
					topicAssignments: makeTags([tagMetalUrn, tagPremiumUrn]),
					isStandIn: false,
				},
				{
					id: '6',
					name: 'Marble Urn',
					description: 'A very nice marble urn.',
					isGuaranteed: true,
					fixedPrice: 14999,
					category: PbProductType.Merchandise,
					subcategory: PbSubcategory.MerchandiseUrn,
					productImageUrl: imageUrl,
					recordType: 'Product',
					refSpbPricingRecommended: null,
					packageRelations: null,
					pricingType: 'Fixed',
					pricing: null,
					topicAssignments: makeTags([tagPremiumUrn]),
					isStandIn: false,
				},
				{
					id: '6.1',
					name: 'Pine Urn',
					description: 'A very affordable urn made of pine.',
					isGuaranteed: true,
					fixedPrice: 14999,
					category: PbProductType.Merchandise,
					subcategory: PbSubcategory.MerchandiseUrn,
					productImageUrl: imageUrl,
					recordType: 'Product',
					refSpbPricingRecommended: null,
					packageRelations: null,
					pricingType: 'Fixed',
					pricing: null,
					topicAssignments: makeTags([tagBasicUrn]),
					isStandIn: false,
				},
				{
					id: 'group-1',
					name: 'Premium Casket Credit',
					description: 'Any one of our finest caskets.',
					isGuaranteed: true,
					fixedPrice: 10000,
					category: PbProductType.Merchandise,
					subcategory: PbSubcategory.MerchandiseCasket,
					productImageUrl: imageUrl,
					recordType: 'Product',
					refSpbPricingRecommended: null,
					packageRelations: null,
					pricingType: 'Fixed',
					pricing: null,
					topicAssignments: makeTags([tagPremiumCasket]),
					isStandIn: true,
				},
				{
					id: 'group-2',
					name: 'Premium Urn Credit',
					description: 'Any one of our finest urns.',
					isGuaranteed: true,
					fixedPrice: 5000,
					category: PbProductType.Merchandise,
					subcategory: PbSubcategory.MerchandiseUrn,
					productImageUrl: imageUrl,
					recordType: 'Product',
					refSpbPricingRecommended: null,
					packageRelations: null,
					pricingType: 'Fixed',
					pricing: null,
					topicAssignments: makeTags([tagPremiumUrn]),
					isStandIn: true,
				},
				{
					id: 'group-basic-casket',
					name: 'Basic Casket',
					description: 'An included casket',
					isGuaranteed: true,
					fixedPrice: 0,
					category: PbProductType.Merchandise,
					subcategory: PbSubcategory.MerchandiseUrn,
					productImageUrl: imageUrl,
					recordType: 'Product',
					refSpbPricingRecommended: null,
					packageRelations: null,
					pricingType: 'Fixed',
					pricing: null,
					topicAssignments: makeTags([tagBasicCasket]),
					isStandIn: true,
				},
				{
					id: '7',
					name: 'Forwarding remains to another funeral firm with casket selected from our funeral home',
					description: `This charge includes removal of remains, necessary services of staff, embalming, necessary
authorizations, local transportation, and delivery to Bozeman or Spokane airport (but not airfare).
This charge does not include dressing, cosmetology, visitation, rites or ceremonies prior to
forwarding of the body. Casket not included.`,
					isGuaranteed: false,
					fixedPrice: 2595,
					category: PbProductType.Service,
					productImageUrl: imageUrl,
					recordType: 'Product',
					refSpbPricingRecommended: null,
					packageRelations: null,
					pricingType: 'Fixed',
					pricing: null,
					topicAssignments: null,
					isStandIn: false,
				},
				{
					id: '8',
					name: 'Air shipping container',
					description: `If transferring remains to another funeral home and not purchasing a casket from us.`,
					isGuaranteed: false,
					fixedPrice: 295,
					category: PbProductType.Service,
					productImageUrl: imageUrl,
					recordType: 'Product',
					refSpbPricingRecommended: null,
					packageRelations: null,
					pricingType: 'Fixed',
					pricing: null,
					topicAssignments: null,
					isStandIn: false,
				},
				{
					id: '9',
					name: 'Receiving of remains from another funeral home',
					description: `This charge includes transportation from Bozeman or Spokane airport, temporary shelter of remains,
transportation of remains to cemetery, and necessary services of staff. This charge does not include
visitation, rites, or ceremonies.`,
					isGuaranteed: false,
					fixedPrice: 2395,
					category: PbProductType.Service,
					productImageUrl: imageUrl,
					recordType: 'Product',
					refSpbPricingRecommended: null,
					packageRelations: null,
					pricingType: 'Fixed',
					pricing: null,
					topicAssignments: null,
					isStandIn: false,
				},
				{
					id: '10',
					name: 'Receiving of cremated remains',
					description: '',
					isGuaranteed: false,
					fixedPrice: 395,
					category: PbProductType.Service,
					productImageUrl: imageUrl,
					recordType: 'Product',
					refSpbPricingRecommended: null,
					packageRelations: null,
					pricingType: 'Fixed',
					pricing: null,
					topicAssignments: null,
					isStandIn: false,
				},
				/** Packages */
				{
					id: 'pkg-1',
					name: 'Immediate Burial with minimum alternative container',
					description: `Our Charge for an immediate burial, without any attendant rites or ceremonies, includes removal and
shelter of remains, refrigeration, local transportation to the cemetery, necessary services of staff and
authorizations.`,
					isGuaranteed: true,
					fixedPrice: 3550,
					category: PbProductType.Package,
					subcategory: PbSubcategory.PackageBurial,
					productImageUrl: imageUrl,
					recordType: 'Package',
					refSpbPricingRecommended: null,
					pricingType: 'Fixed',
					pricing: null,
					packageRelations: {
						data: [
							{
								id: '1',
								refSpbLineProduct: '11',
								refSpbLinePackage: 'pkg-1',
								fixedPrice: 2095,
							},
							{
								id: '2',
								refSpbLineProduct: '14',
								refSpbLinePackage: 'pkg-1',
								fixedPrice: 205,
							},
							{
								id: '3',
								refSpbLineProduct: '29',
								refSpbLinePackage: 'pkg-1',
								fixedPrice: 365,
							},
							{
								id: '4',
								refSpbLineProduct: '30.5',
								refSpbLinePackage: 'pkg-1',
								fixedPrice: 0,
							},
						],
					},
					topicAssignments: null,
					isStandIn: false,
				},
				{
					id: 'pkg-2',
					name: 'Immediate Burial',
					description: `Our Charge for an immediate burial, without any attendant rites or ceremonies, includes removal and
shelter of remains, refrigeration, local transportation to the cemetery, necessary services of staff and
authorizations.`,
					isGuaranteed: true,
					fixedPrice: 3340,
					category: PbProductType.Package,
					subcategory: PbSubcategory.PackageBurial,
					productImageUrl: imageUrl,
					recordType: 'Package',
					refSpbPricingRecommended: null,
					pricingType: 'Fixed',
					pricing: null,
					packageRelations: {
						data: [
							{
								id: '1',
								refSpbLineProduct: '11',
								refSpbLinePackage: 'pkg-2',
								fixedPrice: 0,
							},
							{
								id: '2',
								refSpbLineProduct: '14',
								refSpbLinePackage: 'pkg-2',
								fixedPrice: 0,
							},
							{
								id: '3',
								refSpbLineProduct: '29',
								refSpbLinePackage: 'pkg-2',
								fixedPrice: 0,
							},
						],
					},
					topicAssignments: null,
					isStandIn: false,
				},
				{
					id: 'pkg-3',
					name: 'Burial w/ Casket',
					description: `Burial and casket included`,
					isGuaranteed: true,
					fixedPrice: 3340,
					category: PbProductType.Package,
					subcategory: PbSubcategory.PackageBurial,
					productImageUrl: imageUrl,
					recordType: 'Package',
					refSpbPricingRecommended: null,
					pricingType: 'Fixed',
					pricing: null,
					packageRelations: {
						data: [
							{
								id: '1',
								refSpbLineProduct: '11',
								refSpbLinePackage: 'pkg-4',
								fixedPrice: 0,
							},
							{
								id: '2',
								refSpbLineProduct: '14',
								refSpbLinePackage: 'pkg-4',
								fixedPrice: 0,
							},
							{
								id: '3',
								refSpbLineProduct: '29',
								refSpbLinePackage: 'pkg-4',
								fixedPrice: 0,
							},
							{
								id: '4',
								refSpbLineProduct: 'group-basic-casket',
								refSpbLinePackage: 'pkg-4',
								fixedPrice: 0,
							},
						],
					},
					topicAssignments: null,
					isStandIn: false,
				},
				{
					id: 'pkg-3.1',
					name: 'Deluxe Burial',
					description: `Our recommendation for the best healing opportunity for the family and loved ones.`,
					isGuaranteed: true,
					fixedPrice: 13340,
					category: PbProductType.Package,
					subcategory: PbSubcategory.PackageBurial,
					productImageUrl: imageUrl,
					recordType: 'Package',
					refSpbPricingRecommended: null,
					pricingType: 'Fixed',
					pricing: null,
					packageRelations: {
						data: [
							{
								id: '1',
								refSpbLineProduct: '11',
								refSpbLinePackage: 'pkg-3.1',
								fixedPrice: 0,
							},
							{
								id: '2',
								refSpbLineProduct: '14',
								refSpbLinePackage: 'pkg-3.1',
								fixedPrice: 0,
							},
							{
								id: '3',
								refSpbLineProduct: '29',
								refSpbLinePackage: 'pkg-3.1',
								fixedPrice: 0,
							},
							{
								id: '4',
								refSpbLineProduct: '25',
								refSpbLinePackage: 'pkg-3.1',
								fixedPrice: 0,
							},
							{
								id: '5',
								refSpbLineProduct: '30.1',
								refSpbLinePackage: 'pkg-3.1',
								fixedPrice: 0,
							},
							{
								id: '6',
								refSpbLineProduct: 'group-1',
								refSpbLinePackage: 'pkg-3.1',
								fixedPrice: 10000,
							},
							{
								id: '7',
								refSpbLineProduct: '40',
								refSpbLinePackage: 'pkg-3.1',
								fixedPrice: 0,
							},
						],
					},
					topicAssignments: null,
					isStandIn: false,
				},

				/** Direct Cremations */
				{
					id: 'pkg-4',
					name: 'Direct cremation',
					description: `Our charge for a direct cremation without any attendant rites or ceremonies includes removal of
remains, refrigeration, necessary services of staff and authorization. If you want to arrange a direct
cremation, you can use an alternative container. Alternative containers encase the body and can be
made of material like fiberboard or composite materials (with or without and outside covering). The
containers we provide are heavy cardboard. *(Our price for Direct Cremation includes the crematory
charge.)`,
					isGuaranteed: true,
					fixedPrice: 2960,
					category: PbProductType.Package,
					subcategory: PbSubcategory.Cremation,
					productImageUrl: imageUrl,
					recordType: 'Package',
					refSpbPricingRecommended: null,
					pricingType: 'Fixed',
					pricing: null,
					packageRelations: {
						data: [
							{
								id: '1',
								refSpbLineProduct: '11',
								refSpbLinePackage: 'pkg-4',
								fixedPrice: 0,
							},
							{
								id: '2',
								refSpbLineProduct: '14',
								refSpbLinePackage: 'pkg-4',
								fixedPrice: 0,
							},
							{
								id: '3',
								refSpbLineProduct: '29',
								refSpbLinePackage: 'pkg-4',
								fixedPrice: 0,
							},
							{
								id: '4',
								refSpbLineProduct: '30.6',
								refSpbLinePackage: 'pkg-4',
								fixedPrice: 0,
							},
						],
					},
					topicAssignments: null,
					isStandIn: false,
				},
				{
					id: 'pkg-5',
					name: 'Direct cremation with minimum alternative container',
					description: `Our charge for a direct cremation without any attendant rites or ceremonies includes removal of
remains, refrigeration, necessary services of staff and authorization. If you want to arrange a direct
cremation, you can use an alternative container. Alternative containers encase the body and can be
made of material like fiberboard or composite materials (with or without and outside covering). The
containers we provide are heavy cardboard. *(Our price for Direct Cremation includes the crematory
charge.)`,
					isGuaranteed: true,
					fixedPrice: 3170,
					category: PbProductType.Package,
					subcategory: PbSubcategory.Cremation,
					productImageUrl: imageUrl,
					recordType: 'Package',
					refSpbPricingRecommended: null,
					pricingType: 'Fixed',
					pricing: null,
					packageRelations: {
						data: [
							{
								id: '1',
								refSpbLineProduct: '11',
								refSpbLinePackage: 'pkg-5',
								fixedPrice: 0,
							},
							{
								id: '2',
								refSpbLineProduct: '14',
								refSpbLinePackage: 'pkg-5',
								fixedPrice: 0,
							},
							{
								id: '3',
								refSpbLineProduct: '29',
								refSpbLinePackage: 'pkg-5',
								fixedPrice: 0,
							},
							{
								id: '4',
								refSpbLineProduct: '30.5',
								refSpbLinePackage: 'pkg-5',
								fixedPrice: 0,
							},
							{
								id: '5',
								refSpbLineProduct: '30.6',
								refSpbLinePackage: 'pkg-5',
								fixedPrice: 0,
							},
						],
					},
					topicAssignments: null,
					isStandIn: false,
				},
				{
					id: 'pkg-6',
					name: 'Deluxe cremation',
					description: ``,
					isGuaranteed: true,
					fixedPrice: 2960,
					category: PbProductType.Package,
					subcategory: PbSubcategory.Cremation,
					productImageUrl: imageUrl,
					recordType: 'Package',
					refSpbPricingRecommended: null,
					pricingType: 'Fixed',
					pricing: null,
					packageRelations: {
						data: [
							{
								id: '1',
								refSpbLineProduct: '11',
								refSpbLinePackage: 'pkg-6',
								fixedPrice: 0,
							},
							{
								id: '2',
								refSpbLineProduct: '14',
								refSpbLinePackage: 'pkg-6',
								fixedPrice: 0,
							},
							{
								id: '3',
								refSpbLineProduct: '29',
								refSpbLinePackage: 'pkg-6',
								fixedPrice: 0,
							},
							{
								id: '4',
								refSpbLineProduct: '30.6',
								refSpbLinePackage: 'pkg-6',
								fixedPrice: 0,
							},
							{
								id: '5',
								refSpbLineProduct: 'group-2',
								refSpbLinePackage: 'pkg-6',
								fixedPrice: 4000,
							},
							{
								id: '6',
								refSpbLineProduct: '40',
								refSpbLinePackage: 'pkg-6',
								fixedPrice: 525,
							},
						],
					},
					topicAssignments: null,
					isStandIn: false,
				},

				/** Itemized selections */
				{
					id: '11',
					name: 'Basic services of funeral director and staff',
					description: `Our fee for the services of funeral director and staff includes, but is not limited to, staff to respond
to initial request for service arrangement conference consultation with the family or responsible party,
arrangement of funeral, preparation, certification and filing of necessary documentation, authorizations
and permits, recording vital statistics, preparation and placement of obituary notices, coordination
with those providing other portions of services, e.g. cemetery, crematory, shipping or receiving agents
and others. Also included in this charge are overhead expenses relative to our facility such as
insurance, maintenance and utility expenses, secretarial and administration costs and equipment
and inventory expenses. This fee for our basic services and overhead will be added to the total cost of
the funeral arrangements you select. (This fee is already included in our charges for direct cremations,
immediate burials and forwarding or receiving of remains.)`,
					isGuaranteed: true,
					fixedPrice: 2095,
					category: PbProductType.Service,
					productImageUrl: imageUrl,
					recordType: 'Product',
					refSpbPricingRecommended: null,
					packageRelations: null,
					pricingType: 'Fixed',
					pricing: null,
					topicAssignments: null,
					isStandIn: false,
				},
				{
					id: '12',
					name: 'Embalming, bathing and disinfecting of remains',
					description: `Except in certain special cases, embalming is not required by law. Embalming may be necessary,
however, if you select certain funeral arrangements, such as a funeral with viewing. If you do not want
embalming, you usually have the right to choose an arrangement that does not require you to pay
for it, such as direct cremation or immediate burial. According to 37.166.103 Administrative Rules of
Montana, a body “en route more than 8 hours, or if the termination of common carrier transport occurs
more than 36 hours after the time of death, the body must be either embalmed or refrigerated at 35
degrees F or colder,” or, “when being transported by a private conveyor and the body will not reach
its destination within 48 hours after the time of death, must be either embalmed or refrigerated at 35
degrees F or colder.” This firm assumes no liability whatsoever for the condition or appearance of
remains not embalmed. In such cases, we reserve the right to regulate or restrict viewing as well as
time and manner of ceremony.`,
					isGuaranteed: true,
					fixedPrice: 830,
					category: PbProductType.Service,
					productImageUrl: imageUrl,
					recordType: 'Product',
					refSpbPricingRecommended: null,
					packageRelations: null,
					pricingType: 'Fixed',
					pricing: null,
					topicAssignments: null,
					isStandIn: false,
				},
				{
					id: '13',
					name: 'Sanitary care and disinfection, normal cosmetology, dressing and casketing',
					description: ``,
					isGuaranteed: true,
					fixedPrice: 265,
					category: PbProductType.Service,
					productImageUrl: imageUrl,
					recordType: 'Product',
					refSpbPricingRecommended: null,
					packageRelations: null,
					pricingType: 'Fixed',
					pricing: null,
					topicAssignments: null,
					isStandIn: false,
				},
				{
					id: '14',
					name: 'Care and preparation of un-embalmed remains',
					description: ``,
					isGuaranteed: true,
					fixedPrice: 205,
					category: PbProductType.Service,
					productImageUrl: imageUrl,
					recordType: 'Product',
					refSpbPricingRecommended: null,
					packageRelations: null,
					pricingType: 'Fixed',
					pricing: null,
					topicAssignments: null,
					isStandIn: false,
				},
				{
					id: '15',
					name: 'Care and preparation for receiving from another funeral home',
					description: ``,
					isGuaranteed: true,
					fixedPrice: 205,
					category: PbProductType.Service,
					productImageUrl: imageUrl,
					recordType: 'Product',
					refSpbPricingRecommended: null,
					packageRelations: null,
					pricingType: 'Fixed',
					pricing: null,
					topicAssignments: null,
					isStandIn: false,
				},
				{
					id: '16',
					name: 'Hair dressing',
					description: ``,
					isGuaranteed: false,
					fixedPrice: 0,
					category: PbProductType.Service,
					productImageUrl: imageUrl,
					recordType: 'Product',
					refSpbPricingRecommended: null,
					packageRelations: null,
					pricingType: 'Custom',
					pricing: {
						data: [
							{
								id: '1',
								name: 'Simple',
								price: 65,
							},
							{
								id: '2',
								name: 'Deluxe',
								price: 120,
							},
						],
					},
					topicAssignments: null,
					isStandIn: false,
				},
				{
					id: '17',
					name: 'Special care of autopsied remains',
					description: ``,
					isGuaranteed: true,
					fixedPrice: 210,
					category: PbProductType.Service,
					productImageUrl: imageUrl,
					recordType: 'Product',
					refSpbPricingRecommended: null,
					packageRelations: null,
					pricingType: 'Fixed',
					pricing: null,
					topicAssignments: null,
					isStandIn: false,
				},

				/** Use of Facilities */
				{
					id: '18',
					name: 'Shelter of remains (per day)',
					description: `This charge is made after the 5th day that our facilities are used to shelter the remains.`,
					isGuaranteed: true,
					fixedPrice: 235,
					category: PbProductType.Service,
					productImageUrl: imageUrl,
					recordType: 'Product',
					refSpbPricingRecommended: null,
					packageRelations: null,
					pricingType: 'Fixed',
					pricing: null,
					topicAssignments: null,
					isStandIn: false,
				},
				{
					id: '19',
					name: 'Use of facilities and staff services for visitation (per day)',
					description: `Our services include set-up of visitation area, placement of encased remains, display of
floral arrangements, supervision of and attendance during the visitation at funeral home,
church or other.`,
					isGuaranteed: true,
					fixedPrice: 445,
					category: PbProductType.Service,
					productImageUrl: imageUrl,
					recordType: 'Product',
					refSpbPricingRecommended: null,
					packageRelations: null,
					pricingType: 'Fixed',
					pricing: null,
					topicAssignments: null,
					isStandIn: false,
				},
				{
					id: '20',
					name: 'Use of community room for gathering/reception',
					description: `Catering services are additional`,
					isGuaranteed: true,
					fixedPrice: 655,
					category: PbProductType.Service,
					productImageUrl: imageUrl,
					recordType: 'Product',
					refSpbPricingRecommended: null,
					packageRelations: null,
					pricingType: 'Fixed',
					pricing: null,
					topicAssignments: null,
					isStandIn: false,
				},
				{
					id: '21',
					name: 'Use of community room for funeral service',
					description: `Our services include coordinating the funeral arrangements, supervision of funeral,
and staff to attend funeral ceremony at the funeral home and live streaming of the service.`,
					isGuaranteed: true,
					fixedPrice: 655,
					category: PbProductType.Service,
					productImageUrl: imageUrl,
					recordType: 'Product',
					refSpbPricingRecommended: null,
					packageRelations: null,
					pricingType: 'Fixed',
					pricing: null,
					topicAssignments: null,
					isStandIn: false,
				},
				{
					id: '22',
					name: 'Use of facilities and staff services for memorial service (without body present)',
					description: `Our services include coordinating the memorial service arrangements, supervision
of the memorial service and staff to attend the service at the funeral home.`,
					isGuaranteed: true,
					fixedPrice: 655,
					category: PbProductType.Service,
					productImageUrl: imageUrl,
					recordType: 'Product',
					refSpbPricingRecommended: null,
					packageRelations: null,
					pricingType: 'Fixed',
					pricing: null,
					topicAssignments: null,
					isStandIn: false,
				},
				{
					id: '23',
					name: 'Limited staff and equipment for funeral/memorial service outside of our facilities',
					description: `Our services include coordinating the service arrangements, supervision
of the service and staff to attend ceremony at church or other facility.`,
					isGuaranteed: true,
					fixedPrice: 655,
					category: PbProductType.Service,
					productImageUrl: imageUrl,
					recordType: 'Product',
					refSpbPricingRecommended: null,
					packageRelations: null,
					pricingType: 'Fixed',
					pricing: null,
					topicAssignments: null,
					isStandIn: false,
				},
				{
					id: '24',
					name: 'Equipment and staff services for graveside services',
					description: `Our services include accompaniment of remains to cemetery, supervision
of graveside service and staff to attend service.`,
					isGuaranteed: true,
					fixedPrice: 335,
					category: PbProductType.Service,
					productImageUrl: imageUrl,
					recordType: 'Product',
					refSpbPricingRecommended: null,
					packageRelations: null,
					pricingType: 'Fixed',
					pricing: null,
					topicAssignments: null,
					isStandIn: false,
				},
				{
					id: '25',
					name: 'Refrigeration charge for un-embalmed remains',
					description: `In addition to charges for the shelering of the remains.`,
					isGuaranteed: true,
					fixedPrice: 315,
					category: PbProductType.Service,
					productImageUrl: imageUrl,
					recordType: 'Product',
					refSpbPricingRecommended: null,
					packageRelations: null,
					pricingType: 'Fixed',
					pricing: null,
					topicAssignments: null,
					isStandIn: false,
				},

				/** Other Charges */
				{
					id: '26',
					name: 'Saturday service fee',
					description: ``,
					isGuaranteed: true,
					fixedPrice: 400,
					category: PbProductType.Service,
					productImageUrl: imageUrl,
					recordType: 'Product',
					refSpbPricingRecommended: null,
					packageRelations: null,
					pricingType: 'Fixed',
					pricing: null,
					topicAssignments: null,
					isStandIn: false,
				},
				{
					id: '27',
					name: 'Sunday service fee',
					description: ``,
					isGuaranteed: true,
					fixedPrice: 800,
					category: PbProductType.Service,
					productImageUrl: imageUrl,
					recordType: 'Product',
					refSpbPricingRecommended: null,
					packageRelations: null,
					pricingType: 'Fixed',
					pricing: null,
					topicAssignments: null,
					isStandIn: false,
				},
				{
					id: '28',
					name: 'USPS mailing of cremated remains (Domestic)',
					description: ``,
					isGuaranteed: true,
					fixedPrice: 175,
					category: PbProductType.Service,
					productImageUrl: imageUrl,
					recordType: 'Product',
					refSpbPricingRecommended: null,
					packageRelations: null,
					pricingType: 'Fixed',
					pricing: null,
					topicAssignments: null,
					isStandIn: false,
				},
				{
					id: '29',
					name: 'Transfer of remains to funeral home',
					description: ``,
					isGuaranteed: true,
					fixedPrice: 365,
					category: PbProductType.Service,
					productImageUrl: imageUrl,
					recordType: 'Product',
					refSpbPricingRecommended: null,
					packageRelations: null,
					pricingType: 'Custom',
					pricing: {
						data: [
							{
								id: '1',
								name: 'Within 30 miles',
								price: 365,
							},
							{
								id: '2',
								name: 'Within 50 miles',
								price: 465,
							},
							{
								id: '3',
								name: 'Within 100 miles',
								price: 715,
							},
						],
					},
					topicAssignments: null,
					isStandIn: false,
				},
				{
					id: '30.1',
					name: 'Casket coach (hearse)',
					description: `Add $5 per loaded mile outside of the 30 mile radius.`,
					isGuaranteed: true,
					fixedPrice: 260,
					category: PbProductType.Service,
					productImageUrl: imageUrl,
					recordType: 'Product',
					refSpbPricingRecommended: null,
					packageRelations: null,
					pricingType: 'Custom',
					pricing: {
						data: [
							{
								id: '1',
								name: 'In town',
								price: 260,
							},
						],
					},
					topicAssignments: null,
					isStandIn: false,
				},
				{
					id: '30.2',
					name: 'Funeral SUV',
					description: `Add $5 per loaded mile outside of the 30 mile radius.`,
					isGuaranteed: true,
					fixedPrice: 195,
					category: PbProductType.Service,
					productImageUrl: imageUrl,
					recordType: 'Product',
					refSpbPricingRecommended: null,
					packageRelations: null,
					pricingType: 'Custom',
					pricing: {
						data: [
							{
								id: '2',
								name: 'In Town',
								price: 195,
							},
							{
								id: '3',
								name: 'Minivan/Utility vehicle',
								price: 125,
							},
						],
					},
					topicAssignments: null,
					isStandIn: false,
				},
				{
					id: '30.3',
					name: 'Minivan/Utility vehicle',
					description: `Add $5 per loaded mile outside of the 30 mile radius.`,
					isGuaranteed: true,
					fixedPrice: 125,
					category: PbProductType.Service,
					productImageUrl: imageUrl,
					recordType: 'Product',
					refSpbPricingRecommended: null,
					packageRelations: null,
					pricingType: 'Custom',
					pricing: {
						data: [
							{
								id: '2',
								name: 'In Town',
								price: 125,
							},
						],
					},
					topicAssignments: null,
					isStandIn: false,
				},
				{
					id: '30.5',
					name: 'Alternative container',
					description: ``,
					isGuaranteed: true,
					fixedPrice: 210,
					category: PbProductType.Service,
					productImageUrl: imageUrl,
					recordType: 'Product',
					refSpbPricingRecommended: null,
					packageRelations: null,
					pricingType: 'Fixed',
					pricing: null,
					topicAssignments: null,
					isStandIn: false,
				},
				{
					id: '30.6',
					name: 'Crematory fee',
					description: ``,
					isGuaranteed: true,
					fixedPrice: 1250,
					category: PbProductType.Service,
					productImageUrl: imageUrl,
					recordType: 'Product',
					refSpbPricingRecommended: null,
					packageRelations: null,
					pricingType: 'Fixed',
					pricing: null,
					topicAssignments: null,
					isStandIn: false,
				},
				{
					id: '30.7',
					name: `Additional charge per hour for staff services and/or use of facilities`,
					description: `For partial ceremonies,
body donations or other items not include in the above charges`,
					isGuaranteed: true,
					fixedPrice: 200,
					category: PbProductType.Service,
					productImageUrl: imageUrl,
					recordType: 'Product',
					refSpbPricingRecommended: null,
					packageRelations: null,
					pricingType: 'Fixed',
					pricing: null,
					topicAssignments: null,
					isStandIn: false,
				},
				{
					id: '30.8',
					name: `WWAMI Anatomical donation`,
					description: ``,
					isGuaranteed: true,
					fixedPrice: 1515,
					category: PbProductType.Service,
					productImageUrl: imageUrl,
					recordType: 'Product',
					refSpbPricingRecommended: null,
					packageRelations: null,
					pricingType: 'Fixed',
					pricing: null,
					topicAssignments: null,
					isStandIn: false,
				},

				/** Memorial Merchandise */
				{
					id: '31',
					name: 'Memorial Register Books',
					description: ``,
					isGuaranteed: false,
					fixedPrice: 50,
					category: PbProductType.Merchandise,
					productImageUrl: imageUrl,
					recordType: 'Product',
					refSpbPricingRecommended: null,
					packageRelations: null,
					pricingType: 'Fixed',
					pricing: null,
					topicAssignments: null,
					isStandIn: false,
				},
				{
					id: '32',
					name: 'Acknowledgement cards per 25',
					description: ``,
					isGuaranteed: false,
					fixedPrice: 18,
					category: PbProductType.Merchandise,
					productImageUrl: imageUrl,
					recordType: 'Product',
					refSpbPricingRecommended: null,
					packageRelations: null,
					pricingType: 'Fixed',
					pricing: null,
					topicAssignments: null,
					isStandIn: false,
				},
				{
					id: '33',
					name: 'Service folders',
					description: `Minimum of 50`,
					isGuaranteed: false,
					fixedPrice: 1.75,
					category: PbProductType.Merchandise,
					productImageUrl: imageUrl,
					recordType: 'Product',
					refSpbPricingRecommended: null,
					packageRelations: null,
					pricingType: 'Fixed',
					pricing: null,
					topicAssignments: null,
					isStandIn: false,
				},
				{
					id: '34',
					name: 'Memorial Cards',
					description: `Minimum of 25`,
					isGuaranteed: false,
					fixedPrice: 1.25,
					category: PbProductType.Merchandise,
					productImageUrl: imageUrl,
					recordType: 'Product',
					refSpbPricingRecommended: null,
					packageRelations: null,
					pricingType: 'Fixed',
					pricing: null,
					topicAssignments: null,
					isStandIn: false,
				},
				{
					id: '35',
					name: 'DVD Video Tribute',
					description: `Includes setup of photo slide show of up to 90 photos`,
					isGuaranteed: false,
					fixedPrice: 210,
					category: PbProductType.Merchandise,
					productImageUrl: imageUrl,
					recordType: 'Product',
					refSpbPricingRecommended: null,
					packageRelations: null,
					pricingType: 'Custom',
					pricing: {
						data: [
							{
								id: '1',
								name: 'Video Tribute',
								price: 210,
							},
							{
								id: '2',
								name: '+1 Additional Copy of DVD',
								price: 245,
							},
							{
								id: '3',
								name: '+4 Additional Copies of DVD',
								price: 350,
							},
						],
					},
					topicAssignments: null,
					isStandIn: false,
				},
				{
					id: '36',
					name: 'Memorial Candle (each)',
					description: ``,
					isGuaranteed: false,
					fixedPrice: 25,
					category: PbProductType.Merchandise,
					productImageUrl: imageUrl,
					recordType: 'Product',
					refSpbPricingRecommended: null,
					packageRelations: null,
					pricingType: 'Fixed',
					pricing: null,
					topicAssignments: null,
					isStandIn: false,
				},
				{
					id: '37',
					name: 'Laminated Obituary (each)',
					description: ``,
					isGuaranteed: false,
					fixedPrice: 5,
					category: PbProductType.Merchandise,
					productImageUrl: imageUrl,
					recordType: 'Product',
					refSpbPricingRecommended: null,
					packageRelations: null,
					pricingType: 'Fixed',
					pricing: null,
					topicAssignments: null,
					isStandIn: false,
				},
				{
					id: '38',
					name: 'Custom casket panel',
					description: ``,
					isGuaranteed: false,
					fixedPrice: 195,
					category: PbProductType.Merchandise,
					productImageUrl: imageUrl,
					recordType: 'Product',
					refSpbPricingRecommended: null,
					packageRelations: null,
					pricingType: 'Fixed',
					pricing: null,
					topicAssignments: null,
					isStandIn: false,
				},
				{
					id: '39',
					name: 'Recording of Livestream (each)',
					description: ``,
					isGuaranteed: false,
					fixedPrice: 35,
					category: PbProductType.Merchandise,
					productImageUrl: imageUrl,
					recordType: 'Product',
					refSpbPricingRecommended: null,
					packageRelations: null,
					pricingType: 'Fixed',
					pricing: null,
					topicAssignments: null,
					isStandIn: false,
				},
				{
					id: '40',
					name: 'Memorial Package "A"',
					description: `Register book, 150 folders, 10 Laminates, 1 DVD, 25 Ack. Cards`,
					isGuaranteed: false,
					fixedPrice: 525,
					category: PbProductType.Merchandise,
					productImageUrl: imageUrl,
					recordType: 'Product',
					refSpbPricingRecommended: null,
					packageRelations: null,
					pricingType: 'Fixed',
					pricing: null,
					topicAssignments: null,
					isStandIn: false,
				},
				{
					id: '41',
					name: 'Memorial Package "B"',
					description: `Register book, 50 half sheet memorial cards`,
					isGuaranteed: false,
					fixedPrice: 100,
					category: PbProductType.Merchandise,
					productImageUrl: imageUrl,
					recordType: 'Product',
					refSpbPricingRecommended: null,
					packageRelations: null,
					pricingType: 'Fixed',
					pricing: null,
					topicAssignments: null,
					isStandIn: false,
				},
			],
		},
	}
}
